export enum TRAININGS {
    /**
     * @value Continue training
     */
    CONTINUE_TRAINING = 'TRAININGS.CONTINUE_TRAINING',
    /**
     * @value My current training
     */
    CURRENT_TRAININGS = 'LEARNING.CURRENT_TRAININGS',
    /**
     * @value Launch training
     */
    LAUNCH_TRAINING = 'LEARNING.LAUNCH_TRAINING',
    /**
     * @value No Category
     */
    NO_CATEGORY = 'LEARNING.NO_CATEGORY',
    /**
     * @value Recommendation quiz
     */
    RECOMMENDATION_QUIZ = 'LEARNING.RECOMMENDATION_QUIZ',
    /**
     * @value My recommended training
     */
    RECOMMENDED_TRAININGS = 'LEARNING.RECOMMENDED_TRAININGS',
    /**
     * @value Scorm training
     */
    SCORM_TRAINING = 'TRAININGS.SCORM_TRAINING',
    /**
     * @value Training to do
     */
    TRAININGS_TO_DO = 'LEARNING.TRAININGS_TO_DO',
    /**
     * @value Training course
     */
    TRAINING_COURSE = 'LEARNING.TRAINING_COURSE',
}
